import { pxToRem, styled } from '@project44/manifest-ds';

export const StyledIcon = styled('svg', {
  display: 'inline-block',
  flexShrink: 0,
  fill: 'currentColor',
  fontSize: pxToRem(24),
  height: '1em',
  userSelect: 'none',
  width: '1em',
});
